import React from 'react'
import PropTypes from 'prop-types'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import { CloseButton } from 'shared/UI/CloseButton'

import './style.css.scss'

const Header = (props) => {
  return (
    <section className="search-results-header">
      <h1>‘{props.query}’</h1>
      <h2>
        ({
          props.getTranslation(
            TRANSLATION_VALUE_KEYS.searchResults,
            {resultsCount: props.itemsCount}
          )
        })
      </h2>
      <CloseButton onClose={props.onClose} />
    </section>
  )
}

Header.propTypes = {
  query: PropTypes.string.isRequired,
  itemsCount: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired
}

export default withTranslation(TRANSLATION_KEYS.searchResults)(Header)